import {Injectable} from '@angular/core';
import * as UIModels from '@shared-models/index';
import {UserProfileService} from './user-profile.service';
import {UserRoleEnum} from '@shared-models/common.enums';

@Injectable({
    providedIn: 'root'
})

export class UserRoleService {

    constructor(
        private userProfileService: UserProfileService,
    ) {
    }


    // get isCSBA(): boolean {
    //     const user = this.userProfileService.user;
    //     return user && (user.userRoleId === UIModels.CE.UserRoleEnum.CsbaUS);
    // }
    get isCSBA(): boolean {
        const user = this.userProfileService.user;
        return user && (user.userRoleId === UIModels.CE.UserRoleEnum.CsbaUS
            || user.userRoleId === UIModels.CE.UserRoleEnum.CsbaUSI
            || user.userRoleId === UIModels.CE.UserRoleEnum.Csba);
    }

    get isEmployee(): boolean {
        return this.userProfileService.user && this.userProfileService.user.userRoleId === UIModels.CE.UserRoleEnum.Employee;
    }

    get isFrontDesk(): boolean {
        return this.userProfileService.user && this.userProfileService.user.userRoleId === UIModels.CE.UserRoleEnum.FrontDesk;
    }

    get isSecurityAdmin(): boolean {
        const roleId = this.userProfileService.user.userRoleId;
        return this.userProfileService.user &&
            (roleId === UserRoleEnum.Security
                || roleId === UserRoleEnum.SecurityUS
                || roleId === UserRoleEnum.SecurityUSI);
    }

    getRole(): UIModels.CE.UserRoleEnum {
        return this.userProfileService.user.userRoleId;
    }
}
